export const SET_CONTENT = 'rpb2b-react/monthly-statement/SET_CONTENT';
export type SET_CONTENT = typeof SET_CONTENT;

export const GET_MONTHLY_STATEMENT_IS_PENDING =
  'rpb2b-react/monthly-statement/GET_MONTHLY_STATEMENT_IS_PENDING';
export type GET_MONTHLY_STATEMENT_IS_PENDING = typeof GET_MONTHLY_STATEMENT_IS_PENDING;

export const CLEAR_ALL = 'rpb2b-react/monthly-statement/CLEAR_ALL';
export type CLEAR_ALL = typeof CLEAR_ALL;

export const MONTHLY_STATEMENT_ERROR =
  'rpb2b-react/monthly-statement/MONTHLY_STATEMENT_ERROR';
export type MONTHLY_STATEMENT_ERROR = typeof MONTHLY_STATEMENT_ERROR;

export default {
  SET_CONTENT,
  GET_MONTHLY_STATEMENT_IS_PENDING,
  CLEAR_ALL,
  MONTHLY_STATEMENT_ERROR
};
